import React, { Component } from "react";
import { connect } from "react-redux";
import Helmet from "react-helmet";
import ReactPaginate from "react-paginate";
import queryString from "query-string";

// Components
import BodyWrap from "../utils/BodyWrap";
import ErrorText from "../utils/error-success/ErrorText";
import GeneralLoader from "../GeneralLoader";
import NewsPreviewItem from "../home/news/NewsPreviewItem";

// State
import { getTranslations } from "../../store/actions/translations";
import { getNewsPagination, clearNewsPagination } from "../../store/actions/newsPagination";

const maxItems = 5;

class NewsPage extends Component {
	constructor(props) {
		super(props);

		const query = !!props.location ? queryString.parse(props.location.search) : {};
		let pg = !!query.pg ? query.pg : 0;
		if (pg < 0) pg = 0;

		this.state = {
			pg: pg ? parseInt(pg, 0) : 0,
			max: maxItems
		};
	}

	static initialAction(store, props, translationKey = null) {
		const promises = [];

		// Translations
		const translationSections = ["news_listing"];

		if (translationKey === null) {
			translationKey = props.translationKey;
		}

		const resTranslations =
			store !== null
				? getTranslations([translationKey], translationSections, translationKey)
				: props.getTranslations([translationKey], translationSections, translationKey);
		promises.push(resTranslations);

		const query = !!props.location ? queryString.parse(props.location.search) : {};
		let pg = !!query.pg ? query.pg : 0;
		if (pg < 0) pg = 0;

		// Other stuff the page needs
		if (store !== null) {
			promises.push(getNewsPagination(parseInt(pg, 0) + 1, maxItems));
		} else {
			promises.push(props.getNewsPagination(parseInt(pg, 0) + 1, maxItems));
		}

		return promises;
	}

	// ===================================
	//  LIFE CYCLE
	// ===================================
	componentDidMount() {
		if (!this.props.news.news) {
			NewsPage.initialAction(null, this.props);
		}
	}

	componentWillUnmount() {
		this.props.clearNewsPagination();
	}

	componentDidUpdate(prevProps) {
		// Previous query exists, or we set to empty object
		const nextQuery = !!this.props.location
			? queryString.parse(this.props.location.search)
			: {};

		// Next query exists, or we set to empty object
		const prevQuery = !!prevProps.location ? queryString.parse(prevProps.location.search) : {};

		const prevPg = !!prevQuery.pg ? prevQuery.pg : 0;
		let nextPg = !!nextQuery.pg ? nextQuery.pg : 0;

		if (nextPg < 0) nextPg = 0;

		// console.log("nextPg:", nextPg, "prevPg:", prevPg);

		if (prevPg !== nextPg) {
			this.setState(
				{
					pg: parseInt(nextPg, 0)
				},
				() => {
					this.props.getNewsPagination(this.state.pg + 1, this.state.max);
				}
			);
		}
	}

	// ===================================================================================
	//  HANDLE CHANGES
	// ===================================================================================
	handlePaginationChange = data => {
		// The page number selected
		const selected = data.selected;

		// Get any other query objects
		let queryObj = {};
		queryObj.pg = selected;

		// Make a valid url string (pg=2&q=cow, etc)
		const qs = queryString.stringify(queryObj);

		// Push to history.
		// componentDidUpdate() will take care of triggering the search
		this.props.history.push("?" + qs);
	};

	// ===================================
	//  RENDER
	// ===================================
	renderItems = () => {
		const { records } = this.props.news;

		if (!records || !records.length) {
			return <div>{this.props.translations.sections.news_listing.not_found}</div>;
		}

		return records.map((item, id) => {
			return <NewsPreviewItem key={id} item={item} />;
		});
	};

	renderPagination = () => {
		const { news } = this.props;

		return news.total_pages > 1 ? (
			<ReactPaginate
				previousLabel={""}
				previousLinkClassName={"icon-previous"}
				nextLabel={""}
				nextLinkClassName={"icon-next"}
				breakLabel={"..."}
				breakClassName={"break-me"}
				pageCount={news.total_pages}
				disableInitialCallback={true}
				initialPage={this.state.pg}
				forcePage={this.state.pg}
				marginPagesDisplayed={2}
				pageRangeDisplayed={4}
				onPageChange={this.handlePaginationChange}
				containerClassName={"pagination"}
				subContainerClassName={"pages pagination"}
				activeClassName={"active"}
			/>
		) : null;
	};

	render() {
		const { translationsLoading, translations, isLoading, error, news } = this.props;

		// ===================================
		//	HELMET STUFF
		// ===================================
		let helmet = null;

		let title = "";
		if (this.props.siteInfo.site) {
			title += this.props.siteInfo.site.title;
		}
		if (!!translations.sections["news_listing"]) {
			if (title !== "") title += " | ";
			title += translations.sections["news_listing"].title_bar_title;
		}

		// helmet = (
		// 	<Helmet>
		// 		<title>{title}</title>
		// 		<meta property="og:title" content={title} />
		// 		<meta property="og:description" content={title} />
		// 		<meta property="twitter:title" content={title} />
		// 	</Helmet>
		// );

		return (
			<BodyWrap>
				{/* {helmet} */}
				<main>
					<div className="page-content">
						{translationsLoading ? (
							<GeneralLoader />
						) : (
								<React.Fragment>
									<h1>{translations.sections["news_listing"].title_bar_title}</h1>
									{!!isLoading && <GeneralLoader />}
									{!!error && <ErrorText errors={error} />}
									{!!news && (
										<React.Fragment>
											{this.renderPagination()}
											<div className="section-content section-content--dark-bg mb2">
												{this.renderItems()}
											</div>
											{this.renderPagination()}
										</React.Fragment>
									)}
								</React.Fragment>
							)}
					</div>
				</main>
			</BodyWrap>
		);
	}
}

const mapStateToProps = (state, props) => {
	return {
		siteInfo: state.siteInfo,
		translationsLoading:
			state.translations.isLoading[props.translationKey] === undefined
				? 1
				: state.translations.isLoading[props.translationKey],
		translations: state.translations.translations,
		isLoading: state.newsPagination.isLoading,
		error: state.newsPagination.error === undefined ? null : state.newsPagination.error,
		news: state.newsPagination
	};
};

export default connect(
	mapStateToProps,
	{ getTranslations, getNewsPagination, clearNewsPagination }
)(NewsPage);



// WEBPACK FOOTER //
// ./src/components/news/NewsPage.js